import { Col, Panel, Row } from 'react-bootstrap';
import { IExtendedReconciliationItem, ReconciliationItemStatus } from './models';

interface IProps {
    data: IExtendedReconciliationItem[]
}

const CompletedItems = (props: IProps) => {
    return (
        <Panel defaultExpanded>
            <Panel.Heading>
                Completed Items
            </Panel.Heading>
            <Panel.Body collapsible>
                <Row>
                    <Col xs={12} lg={3}><strong>Name</strong></Col>
                    <Col xs={12} lg={3}><strong>Birth Date</strong></Col>
                    <Col xs={12} lg={3}><strong>Transplant Date</strong></Col>
                    <Col xs={12} lg={3}><strong>Completion Method</strong></Col>
                </Row>
                {props.data.map(item =>
                    <div key={'completed-' + item.index}>
                        <Row>
                            <Col xs={12} lg={3}>{item.firstName} {item.lastName}</Col>
                            <Col xs={12} lg={3}>{item.birthDate}</Col>
                            <Col xs={12} lg={3}>{item.transplantDate}</Col>
                            <Col xs={12} lg={3}>{item.status == ReconciliationItemStatus.CompleteExisting ? 'Updated Existing DASH Entry' : 'Created New DASH Entry'}</Col>
                        </Row>
                    </div>
                )}
            </Panel.Body>
        </Panel>
    );
}

export default CompletedItems;